// Shared helpers for the org location config. The backend seeds new orgs with
// Guatemala City sentinel coords (14.6349, -90.5069), so "unset" means either
// no valid coords at all or the untouched sentinel pair with no address set.
export const DEFAULT_LOCATION = { lat: 14.6349, lng: -90.5069 };

const COORD_EPSILON = 1e-4;

export function isLocationUnset(config) {
  const location = config?.location;
  const lat = location?.lat;
  const lng = location?.lng;
  if (typeof lat !== 'number' || typeof lng !== 'number' || !Number.isFinite(lat) || !Number.isFinite(lng)) {
    return true;
  }
  const isDefaultCoords =
    Math.abs(lat - DEFAULT_LOCATION.lat) < COORD_EPSILON &&
    Math.abs(lng - DEFAULT_LOCATION.lng) < COORD_EPSILON;
  const fullAddress = typeof config?.full_address === 'string' ? config.full_address.trim() : '';
  return isDefaultCoords && !fullAddress;
}
